
import React from "react";

const StateSection = ({ location, index }) => {
  return (
    <section 
      id={location.id}
      className={`py-16 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
    >
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{location.title}</h2>
          <p className="text-gray-700 text-lg mb-4 leading-relaxed">{location.description}</p>
          <ul className="list-disc ml-6 space-y-1 text-gray-700 text-base">
            {location.features.slice(0, 3).map((feature, idx) => (
              <li key={idx} className="text-[17px]">{feature}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default React.memo(StateSection);
